import { Component, OnInit } from '@angular/core';
import { BirthDayRemindersHandler } from './birth-day-reminders.handler.';
import { NotificationService } from '../services/notifications.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';

@Component({
  selector: 'sym-birth-day-reminders',
  templateUrl: './birth-day-reminders.component.html',
  styleUrls: ['./birth-day-reminders.component.scss'],
})
export class BirthDayRemindersComponent extends BirthDayRemindersHandler implements OnInit {
  constructor(
    public service: NotificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, headerService, router, settingService, offlineService);
  }
}
